(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    /* 28.09.2026 (власник): пошук Shopify знаходить товари за початком слова, але
     назви в каталозі латиницею, тому «стар» не знаходив нічого, «старлінк» один
     товар, «міні» два замість шести. Слово кирилицею (від 3 літер), що є
     початком відомої назви, перед запитом замінюємо латинською назвою: «стар»,
     «старлінк» → starlink, «міні» → mini, «мінікіт» → minikit. Українські слова
     з каталогу («адаптація», «амулет», «кабель») не чіпаємо. */
  (() => {
    const LAT = [
      ['старлінк', 'starlink'], ['старлинк', 'starlink'],
      ['міні', 'mini'], ['мини', 'mini'],
      ['мінікіт', 'minikit'], ['миникит', 'minikit'],
      ['екофлоу', 'ecoflow'], ['екофлов', 'ecoflow'], ['экофлоу', 'ecoflow'],
      ['блюетті', 'bluetti'], ['блюетти', 'bluetti'], ['блуетті', 'bluetti'],
    ];
    window.AdaptisSearchQ = (q) =>
      String(q || '').replace(/[а-яіїєґё]+/gi, (w) => {
        const l = w.toLowerCase();
        if (l.length < 3) return w;
        const hit = LAT.find(([c]) => c.startsWith(l));
        return hit ? hit[1] : w;
      });
    /* Сторінка результатів пошуку (кнопка «Дивитися всі», Enter) теж. */
    document.addEventListener(
      'submit',
      (e) => {
        const f = e.target;
        if (!(f instanceof HTMLFormElement) || !/\/search\/?$/.test(new URL(f.action, location.href).pathname)) return;
        const q = f.querySelector('input[name="q"]');
        if (q) q.value = window.AdaptisSearchQ(q.value);
      },
      true
    );
  })();

  document.addEventListener('DOMContentLoaded', () => {
    const searchModal = document.getElementById('search-modal');
    if (!searchModal) return;

    const input = searchModal.querySelector('#cmdk-input');
    if (!input) return;

    const updateSearchModalState = () => {
      const hasQuery = input.value.trim().length > 0;
      searchModal.classList.toggle('search-modal--has-query', hasQuery);
    };

    // Initial state
    updateSearchModalState();

    // Update state while typing
    input.addEventListener('input', updateSearchModalState);
    input.addEventListener('change', updateSearchModalState);
    input.addEventListener('search', updateSearchModalState);

    // When modal opens and input is empty, keep results hidden
    input.addEventListener('focus', updateSearchModalState);

    // Optional: when dialog closes, clear state
    const dialog = searchModal.querySelector('dialog');
    const comp = searchModal.querySelector('predictive-search-component');
    if (dialog) {
      dialog.addEventListener('close', () => {
        /* 28.09.2026: порожній стан тепер видно, тому після запиту повертаємо
           підказки, а не лишаємо старі результати під порожнім полем. */
        const had = input.value.trim().length > 0;
        input.value = '';
        updateSearchModalState();
        if (had && comp && typeof comp.resetSearch === 'function') comp.resetSearch(false);
      });
    }

    /* 28.09.2026: пігулка «Часто шукають» підставляє запит у поле і показує
       результати тут же, як під час набору. Без скрипту це посилання на
       сторінку пошуку. */
    searchModal.addEventListener('click', (e) => {
      const a = e.target instanceof Element ? e.target.closest('[data-ax-q]') : null;
      if (!a) return;
      e.preventDefault();
      input.value = a.getAttribute('data-ax-q') || '';
      input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: input.value }));
    });
  });
  } catch(e) { console.error(e); }
})();

})();
